// AuthCallback.js
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../services/supabase';
import LoadingSpinner from '../../components/Common/LoadingSpinner';
const OAuth2Callback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Get the session after the OAuth redirect
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) throw error;

        if (session?.provider_refresh_token) {
          // Store the tokens
          const { error: tokenError } = await supabase
            .from('user_google_tokens')
            .upsert({
              user_id: session.user.id,
              refresh_token: session.provider_refresh_token,
              access_token: session.provider_token,
              token_expires_at: new Date(Date.now() + 3600 * 1000)
            });

          if (tokenError) {
            console.error('Error storing tokens:', tokenError);
          }
        }

        // Redirect to dashboard after handling the callback
        navigate('/dashboard');
      } catch (error) {
        console.error('Error in OAuth callback:', error);
        navigate('/login');
      }
    };

    handleCallback();
  }, [navigate]);

  return <LoadingSpinner />;
};

export default OAuth2Callback;